export default __webpack_public_path__ + "static/social-municipios_en-476b9894e8665fbaccb76dbcaf62b846.png";